import { hrService } from "../../../../../Api/Services/HRService";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";
import { IBaseResponse } from "../../../../../Types/UserProfileDetails";
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";

export const updateEmployeeStatus = createServiceAsyncThunk<
  IBaseResponse,
  { user_id: number; status: string }
>(
  ACTION_NAMES.UPDATE_EMPLOYEE_STATUS,
  (employeeStatusData) => hrService.employeeStatusUpdate(employeeStatusData),
  ERROR_MESSAGES.UPDATE_EMPLOYEE_STATUS_FAILURE
);

export const updateEmployeeStatusSlice = createGenericSlice<
  IBaseResponse,
  { user_id: number; status: string }
>(SLICE_NAMES.UPDATE_EMPLOYEE_STATUS_SLICE, updateEmployeeStatus);

export const {
  clearError: clearUpdateEmployeeStatusErrors,
  clearSuccessMessage: clearSuccessUpdateEmployeeStatusResponse,
} = updateEmployeeStatusSlice.actions;

export default updateEmployeeStatusSlice.reducer;
